import { Component, OnInit } from '@angular/core';
import { OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { delay } from 'rxjs';
import { Router, RouterModule } from '@angular/router';

import { AppService } from './services/app.service';
import { SessionStorageService } from './services/session-storage.service';
import { LoadingService } from './services/loading.service';
import { authConfig } from './oauth2.config';
import { LoadingComponent } from './components/loading/loading.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [
        RouterModule,
        LoadingComponent
    ]
})
export class AppComponent implements OnInit {
    loading: boolean;
    private erroDeAutenticacaoTratado = false;

    constructor(private oauthService: OAuthService,
        private appService: AppService,
        private sessionStorageService: SessionStorageService,
        private loadingService: LoadingService,
        private router: Router) {

        this.oauthService.configure(authConfig);

        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        this.oauthService.setStorage(this.sessionStorageService.getSessionStorage());
        this.oauthService.setupAutomaticSilentRefresh();

        this.iniciarSessao();

        this.oauthService.events.subscribe(event => {
            if (event instanceof OAuthErrorEvent) {
                if (event.type === 'code_error'
                    && (<any>event).params['error'] === 'access_denied') {
                    // Uma unica retentativa: se o access_denied for estrutural
                    // (consentimento negado, autorizacao ainda nao propagada),
                    // reentrar no SSO em loop deixa o usuario preso sem tela.
                    if (sessionStorage.getItem('retentativa_login') === 'sim') {
                        this.erroDeAutenticacaoTratado = true;
                        this.router.initialNavigation();
                        this.router.navigate(['/acesso-negado']);
                        return;
                    }
                    sessionStorage.setItem('retentativa_login', 'sim');
                    this.oauthService.initLoginFlow();
                }
            }
        });
    }

    /**
     * Inicializa a sessao OAuth. O catch e obrigatorio: as rotas usam
     * withDisabledInitialNavigation(), e o unico ponto que chama
     * router.initialNavigation() esta dentro de loadAccessData(). Sem
     * tratamento, uma rejeicao (erro do SSO no retorno, nonce invalido,
     * falha na troca do code) deixa o app sem navegacao nenhuma — tela
     * branca permanente, sem erro visivel.
     */
    async iniciarSessao(): Promise<void> {
        try {
            await this.oauthService.loadDiscoveryDocumentAndTryLogin({});
            sessionStorage.removeItem('retentativa_login');
            this.appService.loadAccessData();
        } catch (erro) {
            console.error('Falha ao inicializar a sessao', erro);
            this.router.initialNavigation();
            // O handler de OAuthErrorEvent pode ter tratado este mesmo erro de
            // forma mais especifica (access_denied -> /acesso-negado); a lib emite
            // o evento sincrono e rejeita a promise logo depois, entao sem esta
            // guarda o /erro sobrescreveria a navegacao correta.
            if (!this.erroDeAutenticacaoTratado) {
                this.router.navigate(['/erro']);
            }
        }
    }

    ngOnInit() {
        //Caso a aplicação carregue da re-autenticaçao, salva o codigo de callback e fecha a tela
        if (window.name === 'SensitivePopup') {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            if (code) {
                localStorage.setItem('relogin-callback-code', code);
                window.close();
            }
        }

        this.listenToLoading();
    }

    listenToLoading(): void {
        this.loadingService.loadingSub
            .pipe(delay(0))
            .subscribe((loading) => {
                this.loading = loading;
            });
    }
}
